import './Shell.scss';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Device from '@/v2/components/application/Device';
import Loading from '@/v2/components/atoms/Loading';
import query from '@/v2/state/query';
import { ApplicationContext, ApplicationProvider, StorageProvider } from '@/v2/state/providers';
import Analytics from '@/v2/components/application/Analytics';
import RegisterInterestOverlay from '@/v2/components/layouts/RegisterInterestOverlay';
import DisclaimerOverlay from '@/v2/components/layouts/DisclaimerOverlay';
import CookieNoticeOverlay from '@/v2/components/layouts/CookieNoticeOverlay';
import { StateProvider } from '@/v2/state/store';
import { MomentStateProvider } from '@/v2/state/momentState';
import FullscreenOverlay from '@/v2/components/atoms/FullscreenOverlay';
import FullscreenOverlayScroll from '@/v2/components/atoms/FullscreenOverlayScroll';
import PlatformController from '@/v2/components/controllers/PlatformController';
import Navigation from '@/v2/routes/Navigation';
import Design from '@/v2/routes/moments/Design';
import DriverAssist from '@/v2/routes/moments/DriverAssist';
import Performance from '@/v2/routes/moments/Performance';
import Connectivity from '@/v2/routes/moments/Connectivity';

/*
Former moment names:
- Connectivity -> Smartly
- Design -> Serenely
- Driver assist -> Effortlessly
- Performance -> Powerfully
*/

const ShellComponent = ({ data }) => {
    PlatformController();

    if (data.device) {
        return (
            <Router basename={window.HELIOS.aemBasePath}>
                <Analytics adobeTaggingObj={window.HELIOS.adobe.tagging}>
                    <StateProvider>
                        <Device data={data.device}>
                            <FullscreenOverlay />
                            <FullscreenOverlayScroll data={data.device.ios} />
                            <div className="Shell">
                                <React.Suspense fallback={<Loading />}>
                                    <Switch>
                                        <Route exact path="/">
                                            <Redirect to="/scenes.html" />
                                        </Route>
                                        <Route path="/scenes.html" component={Navigation} />
                                        <Route path="/design.html" component={Design} />
                                        <Route path="/driverAssist.html" component={DriverAssist} />
                                        <Route path="/performance.html" component={Performance} />
                                        <Route path="/connectivity.html" component={Connectivity} />
                                    </Switch>
                                </React.Suspense>
                            </div>
                            <RegisterInterestOverlay />
                            <DisclaimerOverlay />
                            <CookieNoticeOverlay />
                        </Device>
                    </StateProvider>
                </Analytics>
            </Router>
        );
    }
    return <Loading />;
};

const ShellRenderer = () => {
    const [data, setter] = useContext(ApplicationContext);
    query(window.HELIOS.selectors.application, setter);
    return <ShellComponent data={data} />;
};

const Shell = () => (
    <StorageProvider>
        <ApplicationProvider>
            <MomentStateProvider>
                <ShellRenderer />
            </MomentStateProvider>
        </ApplicationProvider>
    </StorageProvider>
);

export default Shell;
